const certifications = [
  {
    icon: 'ri-cpu-line',
    title: '소부장 인증',
    description: '소재·부품·장비 기업 확인 및 R&D 가점',
    details: [
      '소재·부품·장비 기업 확인서 발급',
      'R&D 과제 신청 시 가점 부여',
      '정부 지원사업 우선 선정',
      '세제 및 금융 지원 혜택'
    ]
  },
  {
    icon: 'ri-tools-line',
    title: '뿌리기업 확인',
    description: '제조업 근간 기술 보유 기업 우대 혜택',
    details: [
      '뿌리기술 보유 기업 인정',
      '정책자금 융자 우대',
      '기술개발 지원사업 가점',
      '인력 양성 지원'
    ]
  },
  {
    icon: 'ri-shopping-cart-line',
    title: '우수조달',
    description: '나라장터 등록 및 수의계약 지원을 통한 매출 확대',
    details: [
      '나라장터 우수제품 등록',
      '수의계약 가능 (2억원 이하)',
      '공공기관 판로 확대',
      '조달청 인증 마크 사용'
    ]
  }
];

export default function OtherCertification() {
  return (
    <section id="other-certification" className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            기타 인증
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            산업별 특화된 전문 인증 서비스
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-16">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 cursor-pointer group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${cert.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3 leading-tight">{cert.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">{cert.description}</p>
              
              <div className="space-y-2 md:space-y-3">
                {cert.details.map((detail, idx) => (
                  <div key={idx} className="flex items-start gap-2 md:gap-3">
                    <i className="ri-check-double-line text-teal-600 mt-0.5 md:mt-1 flex-shrink-0"></i>
                    <span className="text-xs md:text-sm text-gray-700 leading-relaxed">{detail}</span>
                  </div>
                ))}
              </div>

              <div className="mt-5 md:mt-6 pt-5 md:pt-6 border-t border-gray-200">
                <a
                  href="#contact"
                  className="text-teal-600 font-semibold inline-flex items-center gap-2 cursor-pointer hover:gap-3 transition-all whitespace-nowrap text-sm md:text-base"
                >
                  자세히 알아보기
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-6 md:p-8 border border-teal-100">
            <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-building-line text-xl md:text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 leading-tight">제조업 특화 인증</h3>
                <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                  소부장, 뿌리기업 등 제조업에 특화된 인증으로 정부 지원과 R&D 가점을 확보하세요.
                </p>
              </div>
            </div>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-gray-700 text-sm md:text-base">
                <i className="ri-arrow-right-s-line text-teal-600 flex-shrink-0"></i>
                <span>R&D 과제 신청 시 가점 부여</span>
              </li>
              <li className="flex items-center gap-2 text-gray-700 text-sm md:text-base">
                <i className="ri-arrow-right-s-line text-teal-600 flex-shrink-0"></i>
                <span>정책자금 융자 우대 혜택</span>
              </li>
              <li className="flex items-center gap-2 text-gray-700 text-sm md:text-base">
                <i className="ri-arrow-right-s-line text-teal-600 flex-shrink-0"></i>
                <span>기술개발 지원사업 우선 선정</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-xl p-6 md:p-8 border border-teal-100">
            <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-store-line text-xl md:text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 leading-tight">공공 조달 진입</h3>
                <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                  우수조달 인증으로 나라장터 등록 및 수의계약을 통해 안정적인 매출을 확보하세요.
                </p>
              </div>
            </div>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-gray-700 text-sm md:text-base">
                <i className="ri-arrow-right-s-line text-teal-600 flex-shrink-0"></i>
                <span>나라장터 우수제품 등록</span>
              </li>
              <li className="flex items-center gap-2 text-gray-700 text-sm md:text-base">
                <i className="ri-arrow-right-s-line text-teal-600 flex-shrink-0"></i>
                <span>2억원 이하 수의계약 가능</span>
              </li>
              <li className="flex items-center gap-2 text-gray-700 text-sm md:text-base">
                <i className="ri-arrow-right-s-line text-teal-600 flex-shrink-0"></i>
                <span>공공기관 판로 확대 지원</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
